import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

var _dec, _class;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { addLocation, getReachEstimate, queryLocations, removeLocationItem } from 'redux/modules/audience';
import * as _ from 'lodash';
import Chip from 'material-ui/Chip';
import AutoComplete from 'material-ui/AutoComplete';
import Checkbox from 'material-ui/Checkbox';
import MenuItem from 'material-ui/MenuItem';
import SelectField from 'material-ui/SelectField';
import * as styles from './Audiences.scss';
var AudienceLocation = (_dec = connect(function (state) {
  return {
    audience: state.audience,
    excluded_geo_locations: state.audience && state.audience.FacebookTargetingConfig ? state.audience.FacebookTargetingConfig.data.excluded_geo_locations : null,
    geo_locations: state.audience && state.audience.FacebookTargetingConfig ? state.audience.FacebookTargetingConfig.data.geo_locations : null,
    organization: state.organization.current
  };
}, {
  addLocation: addLocation,
  getReachEstimate: getReachEstimate,
  queryLocations: queryLocations,
  removeLocationItem: removeLocationItem
}), _dec(_class = /*#__PURE__*/function (_Component) {
  _inherits(AudienceLocation, _Component);

  var _super = _createSuper(AudienceLocation);

  function AudienceLocation(props) {
    var _this;

    _classCallCheck(this, AudienceLocation);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "formatLocationTitle", function (location) {
      switch (location.type) {
        case 'city':
          return "".concat(location.name, ", ").concat(location.region, ", ").concat(location.country_name, " ").concat(location.radius);

        case 'region':
          return "".concat(location.name, ", ").concat(location.country_name, " ").concat(location.radius);

        default:
          return "".concat(location.name);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "locationValueSelected", function (value, index) {
      if (index === -1) {
        return;
      }

      var v = _objectSpread(_objectSpread({}, value), {}, {
        radius: parseInt(_this.state.selectedRadius)
      });

      if (value.type === 'country') {
        v = value.country_code;
      } else if (value.type === 'region') {
        v = _objectSpread({}, value);
      } else if (value.type === 'zip') {
        v = _objectSpread({}, value);
      }

      if (v.prettyName) {
        delete v.prettyName;
      }

      var geoType = _this.state.selectedLocationType === 1 ? 'geo_locations' : 'excluded_geo_locations';

      _this.props.addLocation(geoType, v, value.type);
    });

    _defineProperty(_assertThisInitialized(_this), "handleLocationAutoCompleteUpdate", _.debounce(function (query) {
      if (query) {
        // this.props.changeAudienceBuilderValue({
        // locationsIsThinking: true
        // });
        _this.props.queryLocations(query).then(function (res) {
          var filteredData = res.data; // get rid of types that we don't handle
          // https://developers.facebook.com/docs/marketing-api/buying-api/targeting/#location

          filteredData = filteredData.filter(function (d) {
            return d.type !== 'neighborhood' && d.type !== 'subcity' && d.type !== 'large_geo_area' && d.type !== 'geo_market' && d.type !== 'country_group';
          }); //        this.props.changeAudienceBuilderValue({
          //         locationsIsThinking: false
          //      });

          if (!_this.state.locationUS) {
            filteredData = filteredData.filter(function (d) {
              return d.country_code !== 'US';
            });
          }

          if (!_this.state.locationCanada) {
            filteredData = filteredData.filter(function (d) {
              return d.country_code !== 'CA';
            });
          }

          if (!_this.state.locationRegion) {
            filteredData = filteredData.filter(function (d) {
              return d.type !== 'region';
            });
          }

          if (!_this.state.locationCountry) {
            filteredData = filteredData.filter(function (d) {
              return d.type !== 'country';
            });
          }

          if (!_this.state.locationZipcode) {
            filteredData = filteredData.filter(function (d) {
              return d.type !== 'zip';
            });
          }

          if (!_this.state.locationCity) {
            filteredData = filteredData.filter(function (d) {
              return d.type !== 'city';
            });
          }

          if (!_this.state.locationWorld) {
            filteredData = filteredData.filter(function (d) {
              return d.country_code === 'CA' || d.country_code === 'US';
            });
          }

          var prettifiedData = filteredData.map(function (d) {
            var cityOrCountry = d.primary_city ? d.primary_city : d.country_name;
            var region = d.region ? d.region : '';

            if (d.type === 'city') {
              d.prettyName = "".concat(d.name, ", ").concat(region, " (").concat(d.type, ")");
            } else if (d.type === 'zip') {
              d.prettyName = "".concat(d.name, " - ").concat(cityOrCountry, " (").concat(d.type, ")");
            } else {
              d.prettyName = "".concat(d.name, " (").concat(d.type, ")");
            }

            return d;
          });

          _this.setState({
            audienceLocationDataSource: prettifiedData
          });
        });
      }
    }, 200));

    _this.state = {
      autoCompleteDataSource: [],
      dataSource: [],
      locationCountry: true,
      locationRegion: true,
      locationCity: true,
      locationZipcode: true,
      locationUS: true,
      locationCanada: true,
      locationWorld: false,
      audienceLocationDataSource: [],
      selectedInterestType: 1,
      selectedDemographicType: 1,
      selectedCustomAudienceType: 1,
      selectedLocationType: 1,
      selectedRadius: '+10 mi'
    };
    return _this;
  }
  /** *********************************************************
   EVENT HANDLERS
   ***********************************************************/


  _createClass(AudienceLocation, [{
    key: "render",
    value:
    /*
      END LOCATIONS
    */

    /** *********************************************************
     RENDER
     ***********************************************************/
    function render() {
      var _this2 = this;

      var includedLocations = this.props.geo_locations ? Object.keys(this.props.geo_locations).reduce(function (res, key) {
        return res.concat(_this2.props.geo_locations[key]);
      }, []) : [];
      var excludedLocations = this.props.excluded_geo_locations ? Object.keys(this.props.excluded_geo_locations).reduce(function (res, key) {
        return res.concat(_this2.props.excluded_geo_locations[key]);
      }, []) : [];
      /*
        LOCATIONS
      */

      var includedLocationsChips = includedLocations.length ? includedLocations.map(function (i, index) {
        return /*#__PURE__*/React.createElement(Chip, {
          style: {
            marginRight: 6,
            marginBottom: 6
          },
          onRequestDelete: function onRequestDelete() {
            return _this2.props.removeLocationItem('geo_locations', i);
          },
          key: index
        }, typeof i === 'string' ? i : i.type && i.type === 'city' ? "".concat(i.name, " (+").concat(i.radius, " mi)") : i.name);
      }) : null;
      var excludedLocationsChips = excludedLocations.length ? excludedLocations.map(function (i, index) {
        return /*#__PURE__*/React.createElement(Chip, {
          style: {
            marginRight: 6,
            marginBottom: 6
          },
          onRequestDelete: function onRequestDelete() {
            return _this2.props.removeLocationItem('excluded_geo_locations', i);
          },
          key: index
        }, i.name);
      }) : null;
      return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
        className: "row",
        style: {
          flexWrap: 'nowrap',
          marginRight: 0,
          marginLeft: 0,
          marginTop: 16
        }
      }, "Show results from:"), /*#__PURE__*/React.createElement("div", {
        className: "row",
        style: {
          flexWrap: 'nowrap',
          marginRight: 0,
          marginLeft: 0,
          marginTop: 16
        }
      }, /*#__PURE__*/React.createElement(Checkbox, {
        label: "US",
        checked: this.state.locationUS,
        onCheck: function onCheck() {
          _this2.setState({
            locationUS: !_this2.state.locationUS
          });
        },
        style: {
          marginRight: 40,
          width: 'auto'
        }
      }), /*#__PURE__*/React.createElement(Checkbox, {
        label: "Canada",
        checked: this.state.locationCanada,
        onCheck: function onCheck() {
          _this2.setState({
            locationCanada: !_this2.state.locationCanada
          });
        },
        style: {
          marginRight: 40,
          width: 'auto'
        }
      }), /*#__PURE__*/React.createElement(Checkbox, {
        label: "Worldwide",
        checked: this.state.locationWorld,
        onCheck: function onCheck() {
          _this2.setState({
            locationWorld: !_this2.state.locationWorld
          });
        },
        style: {
          width: 'auto'
        }
      })), /*#__PURE__*/React.createElement("div", {
        className: "row",
        style: {
          flexWrap: 'nowrap',
          margin: '16px 0 0'
        }
      }, "Show location types:"), /*#__PURE__*/React.createElement("div", {
        className: "row",
        style: {
          flexWrap: 'nowrap',
          margin: '16px 0'
        }
      }, /*#__PURE__*/React.createElement(Checkbox, {
        label: "Country",
        checked: this.state.locationCountry,
        onCheck: function onCheck() {
          _this2.setState({
            locationCountry: !_this2.state.locationCountry
          });
        },
        style: {
          marginRight: 40,
          width: 'auto'
        }
      }), /*#__PURE__*/React.createElement(Checkbox, {
        label: "Region",
        checked: this.state.locationRegion,
        onCheck: function onCheck() {
          _this2.setState({
            locationRegion: !_this2.state.locationRegion
          });
        },
        style: {
          marginRight: 40,
          width: 'auto'
        }
      }), /*#__PURE__*/React.createElement(Checkbox, {
        label: "City",
        checked: this.state.locationCity,
        onCheck: function onCheck() {
          _this2.setState({
            locationCity: !_this2.state.locationCity
          });
        },
        style: {
          marginRight: 40,
          width: 'auto'
        }
      }), /*#__PURE__*/React.createElement(Checkbox, {
        label: "Zipcode",
        checked: this.state.locationZipcode,
        onCheck: function onCheck() {
          _this2.setState({
            locationZipcode: !_this2.state.locationZipcode
          });
        },
        style: {
          marginRight: 40,
          width: 'auto'
        }
      })), /*#__PURE__*/React.createElement("div", {
        className: "row"
      }, /*#__PURE__*/React.createElement("div", {
        className: "col-xs-3"
      }, /*#__PURE__*/React.createElement(SelectField, {
        value: this.state.selectedLocationType,
        style: {
          top: 10,
          width: '100%'
        },
        onChange: function onChange(e, i, val) {
          return _this2.setState({
            selectedLocationType: val
          });
        }
      }, /*#__PURE__*/React.createElement(MenuItem, {
        value: 1,
        primaryText: 'Include'
      }), /*#__PURE__*/React.createElement(MenuItem, {
        value: 2,
        primaryText: 'Exclude'
      }))), /*#__PURE__*/React.createElement("div", {
        className: "col-xs-3"
      }, /*#__PURE__*/React.createElement(SelectField, {
        value: this.state.selectedRadius,
        style: {
          top: 10,
          width: '100%'
        },
        onChange: function onChange(e, i, val) {
          return _this2.setState({
            selectedRadius: val
          });
        }
      }, /*#__PURE__*/React.createElement(MenuItem, {
        value: '+10 mi',
        primaryText: '+10 mi'
      }), /*#__PURE__*/React.createElement(MenuItem, {
        value: '+15 mi',
        primaryText: '+15 mi'
      }), /*#__PURE__*/React.createElement(MenuItem, {
        value: '+20 mi',
        primaryText: '+20 mi'
      }), /*#__PURE__*/React.createElement(MenuItem, {
        value: '+25 mi',
        primaryText: '+25 mi'
      }), /*#__PURE__*/React.createElement(MenuItem, {
        value: '+30 mi',
        primaryText: '+30 mi'
      }), /*#__PURE__*/React.createElement(MenuItem, {
        value: '+35 mi',
        primaryText: '+35 mi'
      }), /*#__PURE__*/React.createElement(MenuItem, {
        value: '+40 mi',
        primaryText: '+40 mi'
      }), /*#__PURE__*/React.createElement(MenuItem, {
        value: '+45 mi',
        primaryText: '+45 mi'
      }), /*#__PURE__*/React.createElement(MenuItem, {
        value: '+50 mi',
        primaryText: '+50 mi'
      }))), /*#__PURE__*/React.createElement("div", {
        className: "col-xs-5"
      }, /*#__PURE__*/React.createElement(AutoComplete, {
        fullWidth: true,
        hintText: "City, State or Zip Code",
        onUpdateInput: this.handleLocationAutoCompleteUpdate,
        onNewRequest: this.locationValueSelected,
        dataSourceConfig: {
          text: 'prettyName',
          value: 'key'
        },
        dataSource: this.state.audienceLocationDataSource,
        filter: AutoComplete.fuzzyFilter,
        openOnFocus: true,
        textFieldStyle: {
          top: 10,
          width: '100%'
        }
      })), /*#__PURE__*/React.createElement("div", {
        className: "col-xs-1"
      })), /*#__PURE__*/React.createElement("div", {
        className: "row"
      }, !!includedLocations.length && /*#__PURE__*/React.createElement("div", {
        className: "col-xs-12"
      }, /*#__PURE__*/React.createElement("h5", {
        className: styles.targetingRowHeader
      }, "Included Locations"), /*#__PURE__*/React.createElement("div", {
        className: styles.chipWrap
      }, includedLocationsChips)), !!excludedLocations.length && /*#__PURE__*/React.createElement("div", {
        className: "col-xs-12"
      }, /*#__PURE__*/React.createElement("h5", {
        className: styles.targetingRowHeader
      }, "Excluded Locations"), /*#__PURE__*/React.createElement("div", {
        className: styles.chipWrap
      }, excludedLocationsChips))));
    }
  }]);

  return AudienceLocation;
}(Component)) || _class);
export { AudienceLocation as default };